<script lang="ts">
    import type {LoanRequestOption, PalmknihyAudioLoanability} from 'typings/portaro.be.types';
    import {getInjector, getLocalization, getSanitize} from 'core/svelte-context/context';
    import {LoanRequestFormService} from '../loan-request-form.service';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';
    import LoginFirstButton from './shared/LoginFirstButton.svelte';
    import SendLoanRequestButton from './shared/SendLoanRequestButton.svelte';
    import PalmknihyHelpDisclosure from './shared/PalmknihyHelpDisclosure.svelte';
    import PalmknihySupportedDevices from './shared/PalmknihySupportedDevices.svelte';
    import OpenOnPalmkihyLink from './shared/OpenOnPalmkihyLink.svelte';
    import LoanOptionPanelBody from './shared/LoanOptionPanelBody.svelte';

    export let option: LoanRequestOption<PalmknihyAudioLoanability>;

    const localize = getLocalization();
    const sanitize = getSanitize();
    const service = getInjector().getByClass(LoanRequestFormService);

    $: showLoginButtonFirst = service.requiresLogin(option);
    $: requesterEmail = option.formObject.requester.email;
</script>

<KpGenericPanel>
    <strong slot="heading">
        {localize(/* @kp-localization loan.palmknihy.BorrowAudiobookViaPalmknihy */ 'loan.palmknihy.BorrowAudiobookViaPalmknihy')}
    </strong>

    <LoanOptionPanelBody>
        {#if !showLoginButtonFirst}
            <PalmknihyHelpDisclosure {requesterEmail}/>
        {/if}

        <PalmknihySupportedDevices/>

        <div>
            {@html sanitize(localize(/* @kp-localization loan.palmknihy.DodatecneInformace */ 'loan.palmknihy.DodatecneInformace'))}
        </div>

        <OpenOnPalmkihyLink capability="{option.capability}"/>

        {#if showLoginButtonFirst}
            <LoginFirstButton/>
        {:else}
            <SendLoanRequestButton {option} apiPath="/loan-items/request/externalLendingRequest">
                {localize(/* @kp-localization loan.palmknihy.BorrowAudiobook */ 'loan.palmknihy.BorrowAudiobook')}
            </SendLoanRequestButton>

            <small class="text-muted">
                {@html sanitize(localize(/* @kp-localization loan.palmknihy.KliknutimPotvrzujeteSouhlasSVOP */ 'loan.palmknihy.KliknutimPotvrzujeteSouhlasSVOP'))}
            </small>
        {/if}
    </LoanOptionPanelBody>
</KpGenericPanel>